var $84d1f6fbb776dfbc$exports = {};
const $84d1f6fbb776dfbc$var$table = document.querySelector(".table--js");
console.log($84d1f6fbb776dfbc$var$table);
for(let i = 0; i < localStorage.length; i++){
    let key = localStorage.key(i);
    let value = localStorage.getItem(localStorage.key(i));
    let el = document.createElement("tr");
    el.classList = "border";
    el.innerHTML = `<td>${i + 1}</td><td>${key}</td><td>${value}</td>`;
    $84d1f6fbb776dfbc$var$table.appendChild(el);
}


//# sourceMappingURL=history.b7c9e372.js.map
